import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IZeitArtsQuerySorter extends ISorter {
   id?: ISorterExpression;
   name?: ISorterExpression;
   beschreibung?: ISorterExpression;
}

export const ZeitArtsQuerySorterConfig: ISorterConfig = [
   SorterConfig('id', 'ZEITEN.Models.ZEIT_ART.Propertys.ID.title'),
   SorterConfig('name', 'ZEITEN.Models.ZEIT_ART.Propertys.NAME.title'),
   SorterConfig('beschreibung', 'ZEITEN.Models.ZEIT_ART.Propertys.BESCHREIBUNG.title'),
];
